module.exports = __webpack_public_path__ + "img/2.9cca19c7.jpg";